// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientListFilter_container__jOl3r"};